import React from 'react';
// import { Link } from 'react-router-dom';

const CTA = () => {
  return (
    <section className="py-20 bg-gradient-to-r from-[#0F172A] to-[#1E293B] text-white">
      <div className="container mx-auto px-6 text-center">
        <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6">Ready to Transform Your Financial Strategy?</h2>
        <p className="text-xl text-gray-300 mb-10 max-w-3xl mx-auto">
          Whether you're scaling your startup or investing in the next big idea, our team is ready to help you achieve your goals.
        </p>
        <div className="flex flex-col sm:flex-row justify-center gap-4">
          <a 
            href="/#contact" 
            className="bg-transparent border-2 border-white hover:bg-white/10 text-white px-8 py-4 rounded-lg font-semibold transition duration-300 shadow-lg hover:shadow-xl hover:-translate-y-1"
          >
            Get Started
          </a>
          {/* <Link 
            to="tel:1234567890" 
            className="bg-white hover:bg-gray-100 text-[#0F172A] px-8 py-4 rounded-lg font-semibold transition duration-300 shadow-lg hover:shadow-xl hover:-translate-y-1"
          >
            Schedule Call
          </Link> */}
        </div>
      </div>
    </section>
  );
};

export default CTA;